<!--
 * @Descripttion: 活动详情
 * @Author: jschen
 * @Date: 2021-08-29 17:26:02
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-03 16:44:59
-->
<template>
    <div class="cultural-activities-details--page">
        <div class="system-box house-table-box">
            <header class="top-header">
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item v-if="isHome" :to="{ path: '/work-portal/index' }">
                            <i class="icon-home"></i> 首页
                        </el-breadcrumb-item>
                        <el-breadcrumb-item v-else :to="{ path: '/work-portal/user-center' }">
                            <i class="icon-home"></i> 个人中心
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>广告详情</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </header>
            <div class="center-context">
                <div>
                    <adv-item></adv-item>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AdvItem from "./components/adv-item.vue";
export default {
    name: "AdvDetails",
    components: {
        AdvItem,
    },
    data() {
        return {
            isHome: false,
        };
    },
    created() {
        this.formatHome();
    },
    activated() {
        this.formatHome();
    },
    methods: {
        formatHome() {
            this.isHome = this.$route.query.source === "dwwb";
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
